// Use defaut timeout from Confluence
// https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/experience-tracker/src/ExperienceTimeout.ts#2
export const DEFAULT_TIMEOUT_USER_EXP = 60000; // 60s
export const DEFAULT_TIMEOUT_OPEN_DIALOG = 15000; // 15s

export enum UserExperienceNames {
	CREATE_TEAM = 'createTeam',
	CREATE_TEAM_OPEN_DIALOG = 'createTeam/openDialog',
	CREATE_TEAM_SUBMIT = 'createTeam/create',
	// a compound experience
	TEAM_PROFILE_PAGE = 'teamProfile/render',
	TEAM_PROFILE_MEMBERS = 'teamProfile/membersPanel',
	TEAM_PROFILE_LINKS = 'teamProfile/links',
	TEAM_PROFILE_WORKED_ON = 'teamProfile/workedOn',
	TEAM_PROFILE_TEAM_ABOUT = 'teamProfile/teamAboutPanel',
	TEAM_PROFILE_PROJECTS_AND_GOALS = 'teamProfile/projectsAndGoals',
	TEAM_PROFILE_HELP_POINTERS = 'teamProfile/helpPointers',
	TEAM_PROFILE_KUDOS = 'teamProfile/kudos',
	TEAM_PROFILE_SOFTWARE_COMPONENTS = 'teamProfile/softwareComponents',
	USER_PROFILE_AI_TOPICS = 'userProfile/aiTopics',
	// a compound experience
	USER_PROFILE_PAGE = 'userProfile/render',
	USER_PROFILE_PAGE_SLOW = 'userProfile/renderSlow',
	USER_PROFILE_WORKED_ON = 'userProfile/workedOn',
	USER_PROFILE_CONTAINERS = 'userProfile/container',
	USER_PROFILE_USER_ABOUT = 'userProfile/userAbout',
	USER_PROFILE_COLLABORATORS = 'userProfile/collaborators',
	USER_PROFILE_USERS_TEAMS = 'userProfile/usersTeams',
	USER_PROFILE_USER_MANAGER = 'userProfile/userManager',
	USER_PROFILE_TAG = 'userProfile/tag',
	// a compound experience
	SEARCH_HOME_PAGE = 'searchHomePage/render',
	SEARCH_HOME_PAGE_COLLABORATORS = 'searchHomePage/collaborators',
	SEARCH_HOME_PAGE_YOUR_TEAMS = 'searchHomePage/yourTeams',
	USER_PROFILE_PROJECTS_AND_GOALS = 'userProfile/projectsAndGoals',
	USER_PROFILE_MANAGERS_AND_TEAMS = 'userProfile/managersAndTeams',
	USER_PROFILE_KUDOS = 'userProfile/kudos',
	// edit team name or description from Team profile page
	EDIT_TEAM_NAME_OR_DESCRIPTION = 'editTeamNameOrDescription',
	// remove team member
	REMOVE_TEAM_MEMBER = 'removeTeamMember',
	REMOVE_TEAM_MEMBER_OPEN_DIALOG = 'removeTeamMember/openDialog',
	REMOVE_TEAM_MEMBER_SUBMIT = 'removeTeamMember/submit',
	// upload user avatar from User profile page
	UPLOAD_USER_AVATAR = 'uploadUserAvatar',
	UPLOAD_HEADER_IMAGE = 'uploadHeaderImage',
	// team membership control changing
	MEMBERSHIP_CONTROL_CHANGE = 'membershipControl/change',
	MEMBERSHIP_CONTROL_HANDLE_REQUESTS = 'membershipControl/handleRequests',
	MEMBERSHIP_CONTROL_TEAM_TYPE = 'membershipControl/teamType',
	// agent profile page
	AGENT_PROFILE_PAGE = 'agentProfile/render',
}

export const TEAM_PROFILE_PAGE_SUB_EVENT_NAMES = [
	UserExperienceNames.TEAM_PROFILE_MEMBERS,
	UserExperienceNames.TEAM_PROFILE_LINKS,
	UserExperienceNames.TEAM_PROFILE_WORKED_ON,
	UserExperienceNames.TEAM_PROFILE_TEAM_ABOUT,
];

export const USER_PROFILE_PAGE_SUB_EVENT_NAMES = [
	UserExperienceNames.USER_PROFILE_USER_ABOUT,
	UserExperienceNames.USER_PROFILE_USERS_TEAMS,
	UserExperienceNames.USER_PROFILE_WORKED_ON,
	UserExperienceNames.USER_PROFILE_CONTAINERS,
	UserExperienceNames.USER_PROFILE_COLLABORATORS,
];

export const SEARCH_HOME_PAGE_SUB_EVENT_NAMES = [
	UserExperienceNames.SEARCH_HOME_PAGE_COLLABORATORS,
	UserExperienceNames.SEARCH_HOME_PAGE_YOUR_TEAMS,
];

export const CREATE_TEAM_FLOW_SUB_EVENT_NAMES = [
	UserExperienceNames.CREATE_TEAM_OPEN_DIALOG,
	UserExperienceNames.CREATE_TEAM_SUBMIT,
];

export const REMOVE_TEAM_MEMBER_SUB_EVENT_NAMES = [
	UserExperienceNames.REMOVE_TEAM_MEMBER_OPEN_DIALOG,
	UserExperienceNames.REMOVE_TEAM_MEMBER_SUBMIT,
];
